import { apiService } from '../api/api-client';
import type { Permission } from '@/types';

export interface UserInfo {
  email: string;
  first_name: string | null;
  last_name: string | null;
  onboarding_seen_version: number;
  /** Display role — a single group name; the RBAC catalog is admin-managed (LR-257).
   *  Optional so partial mocks/older callers still type-check; consumers default it. */
  role?: string;
  /** Capability codenames the UI gates on (consumers default to [] when absent). */
  permissions?: Permission[];
}

class AuthService {
  async googleAuth(googleToken: string): Promise<UserInfo> {
    return apiService.post<UserInfo>('/auth/google/', { id_token: googleToken });
  }

  async emailPasswordAuth(email: string, password: string): Promise<UserInfo> {
    return apiService.post<UserInfo>('/auth/login/', { email, password });
  }

  async logout(): Promise<void> {
    await apiService.post('/auth/logout/');
  }

  async getMe(): Promise<UserInfo> {
    return apiService.get<UserInfo>('/auth/me/');
  }

  /**
   * Persist the highest tour version this user has completed.
   * Backend rejects negative values with HTTP 400.
   */
  async markOnboardingSeenVersion(version: number): Promise<UserInfo> {
    return apiService.patch<UserInfo>('/auth/me/', {
      onboarding_seen_version: version,
    });
  }
}

export const authService = new AuthService();
